<template>
  <div id="appReservation" style="max-width: 1200px;background-color: rgb(251, 251, 251);margin: 0 auto !important;float: none !important; min-height: 95%;border-radius:5px;padding-top:10px;margin-top:10px;margin-bottom:10px">
   <header>

     <loading :active.sync="showLoader" :is-full-page="fullPage"></loading>

           <!-- main menu area start -->
        <div class="header-main" style="margin-bottom: 15px;margin-top: 15px" v-if="!isCustAppoint">
            <div class="container">
                <div class="row align-items-center" v-if="isInFrame">
                   <a href="/" target="_blank"><i class="ion-info" style="color:#ff0000;text-decoration:underline">Open deze reservatie op je mobiel toestel</i></a>
                </div>
                <div class="row align-items-center" v-if="settingsData.IsOnlyExistingCust" style="text-align:center;color:#ff0000;background-color:#eeeeee;border-radius:10px;margin:5px;padding:5px;padding-left:14px;padding-right:14px">
                   Online reservatie enkel mogelijk voor bestaande klanten.
                </div>
                <div class="row align-items-center">
                    <div class="col-lg-12 col-md-6 col-sm-10" v-if="!isPaymentPage">
                        <div class="logo">
                            <router-link :to="navRoot" >
                                  <h3>{{this.settingsData.StoreName}}</h3>
                                  <h5>{{this.settingsData.StoreAddress}}</h5>
                              </router-link>
                        </div>
                    </div>
                   
                    <div class="col-lg-12 col-md-6 col-sm-8 ml-auto">
                        <div class="header-setting-option">
                           <div class="header-mini-cart" v-show="(webshopAddress.length > 5)">
                                <a :href="webshopAddress" target="_blank">
                                <div class="mini-cart-btn">
                                    <i class="ion-android-globe"></i>
                                </div>
                                <span style="font-size:10px;color: #111111;">Webshop</span>
                                </a>
                            </div>

                            <div style="width:25px;color:#eeeeee">&nbsp;|&nbsp;</div>

                           <router-link :to="'/myaccount'" class="product-link">
                            <div class="header-mini-cart" v-show="showBasket">
                                <div class="mini-cart-btn">
                                    <i class="ion-person"></i>
                                </div>
                                <span style="font-size:10px;color: #111111;">Account</span>
                            </div>
                           </router-link>
                           <router-link :to="'/cart'" class="product-link">
                            <div class="header-mini-cart" v-show="showBasket" v-if="!isStoreClosed">
                                <div class="mini-cart-btn">
                                    <i class="ion-bag"></i>
                                    <span class="cart-notification" v-bind:style="{ 'background-color': colorApp}">{{ this.$store.state.cart.length }}</span>
                                </div>
                            </div>
                           </router-link>
                        </div>
                    </div>
                    <div class="col-12 d-block d-lg-none">
                        <div class="mobile-menu"></div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="header-main" style="margin-bottom: 15px;margin-top: 15px">
           <div class="container">
                <div class="row align-items-center">
                    <div class="col-24">
                        <div class="logo">
                             <h3>{{this.settingsData.StoreName}}</h3>
                                  {{this.settingsData.StoreAddress}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- main menu area end -->
        <router-view></router-view>

    </header>
  </div>
</template>


<script>


import Vue from 'vue';
//import toastr from 'toastr'
import myHttpApi from "./api/myhttpapi"
import Loading from 'vue-loading-overlay'; // Import stylesheet

import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';

import 'vue-loading-overlay/dist/vue-loading.css';

import {
    SPINNER_SHOW,
    SPINNER_HIDE
  } from './store/mutation-types'

import {
  ADD_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_SUCCESS,
  REMOVE_PRODUCT_SUCCESS
} from './store/mutation-types'

Vue.use(VuejsDialog);

export default {
  name: 'appReservation',
  data () {
    return {
      isLoading: false,
      fullPage: true,
      cartItems: this.$store.state.cart,
      settingsData : {},
      colorApp : '',
      showBasket : true,
      isPaymentPage : false,
      isStoreClosed : false,
      webshopAddress : '',
      isInFrame : false,
      metaInfo: {
            title: ''
        },
    }
  },
  components: {
      Loading
  },
  created () {

    document.title = "Reserveer online bij " + Vue.$storeSettings.StoreName
    this.isInFrame = !(self==top)

    this.webshopAddress = Vue.$storeSettings.WebShopAddress;
    if (this.webshopAddress == null) this.webshopAddress = "";
    if (this.webshopAddress == undefined) this.webshopAddress = "";

    if (this.$route.name == "PaymentStatus")  {Vue.$isPaymentStatus = true;}
    if (this.$route.name == "CustAppoint")  {Vue.$isCustAppoints = true;}
    else if (this.$route.name == "StoreAppoint")  { Vue.$isCustAppoints = true;}
  
    this.loadSettings (); //Niet verplaatsen!

    if (this.$route.name == "PaymentStatus")  {Vue.$isPaymentStatus = true;}
    else if (this.$route.name == "CustAppoint")  {Vue.$isCustAppoints = true;}
    else if (this.$route.name == "StoreAppoint")  { Vue.$isCustAppoints = true;}
    else
    {
       this.$router.push('/')    //Force to root on reload ?
    }

    if (Vue.$isPaymentStatus) this.isPaymentPage = true;
  },
  computed: {
    cartItemsCount () {
      return this.cartItems.length
    },
    showLoader () {
      return this.$store.state.showLoader
    },
    getColorApp () {
        if (Vue.$storeSettings == undefined) return "";
        return Vue.$storeSettings.ColorApp;
    },
    isCustAppoint () {
      return Vue.$isCustAppoints;
    },
    navRoot () {
      //console.log ("base: " + Vue.$baseUrl);
      return Vue.$baseUrl;
    }
  },
  methods: {
      navigate (item) {
        this.$router.push(item);
      },
      navigateBack () {
        this.$router.go(-1);
      },
      loadSettings () {
         
          Vue.$errorStartup = false;
          this.settingsData = Vue.$storeSettings
          this.colorApp = this.settingsData.ColorApp

          if (Vue.$isPosworld === false) Vue.$storeSettings.LayoutKind = 1; //Salonworld
          //console.log ("layout:" +  Vue.$storeSettings.LayoutKind);

          if (Vue.$storeSettings.LayoutKind == 1) Vue.$baseUrl = '/list';
          else Vue.$baseUrl = '/listws';

          if (Vue.$storeSettings.LayoutKind  > 9)
          {
             if (Vue.$storeSettings.LayoutKind % 2 == 1) Vue.$baseUrl = '/list';
          }

          if (Vue.$storeSettings.StoreName == null)
          {
              console.log ("no store found");
              this.settingsData = {StoreName : 'Geen shop gevonden', StoreAddress : 'op dit domain'}
              this.showBasket = false;
          }

          if (Vue.$storeSettings.IsStoreClosed)
          {
            this.isStoreClosed = true
            this.$router.push({ path: '/storeclosed' })
            return;
          }

          
          if (this.$route.name == "PaymentStatus")  {Vue.$isPaymentStatus = true;}

          var canRoute = true;
          if (Vue.$isCustAppoints) canRoute = false;
          if (Vue.$isPaymentStatus) canRoute = false;

          if ((Vue.$storeSettings.IsHasWelcomeMsg) && (canRoute))
          {
            if (Vue.$storeSettings.WelcomeMsg === undefined) Vue.$storeSettings.WelcomeMsg = "";
            if (Vue.$storeSettings.WelcomeMsg === null) Vue.$storeSettings.WelcomeMsg = "";

            var contentMsg = String (Vue.$storeSettings.WelcomeMsg).split("\n").join("<br>");
            let message = {
              title: Vue.$storeSettings.StoreName,
              body: contentMsg,
            };
            let options = {
              html : true,
              okText: 'OK',
              verification: 'Ok'
            }
            
            this.$dialog.alert (message, options);
          }

          if (canRoute) 
          { 
            //console.log (this.$router.currentRoute.path)
            //this.$router.push({ path: Vue.$baseUrl })  //v6.2.x
            if (this.$router.currentRoute.path !==  Vue.$baseUrl) this.$router.push({ path: Vue.$baseUrl })
          }
      }
    },
}
</script>
<style>
.dg-btn--ok {
    color: #111111;
    background-color: #fefefe;
    border-color: #111111;
}
.dg-container {
  top: 7%;
}
</style>



// WEBPACK FOOTER //
// src/AppReservation.vue